export class TimeoutException extends Error {
  constructor(public message: string = 'Timeout exceeded') {
    super(message);
    this.name = 'TimeoutException';
    Object.setPrototypeOf(this, TimeoutException.prototype);
  }
}
